import React from 'react';
var Cerrar = function (_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "14.828", height: "14.828", viewBox: "0 0 14.828 14.828" },
        React.createElement("g", { id: "Group_515", "data-name": "Group 515", transform: "translate(-267.586 -21.586)" },
            React.createElement("g", { id: "mn-openmenu", transform: "translate(269 23)" },
                React.createElement("g", { id: "vuesax_linear_menu", "data-name": "vuesax/linear/menu", transform: "translate(0 0)" },
                    React.createElement("g", { id: "menu", transform: "translate(0)" },
                        React.createElement("path", { id: "Path_324", "data-name": "Path 324", d: "M2.667,6.925l12,12", transform: "translate(-2.667 -6.925)", fill: "none", stroke: "var(--icon-primary-dark)", strokeLinecap: "round", strokeWidth: "2" }),
                        React.createElement("path", { id: "Path_325", "data-name": "Path 325", d: "M14.667,6.925l-12,12", transform: "translate(-2.667 -6.925)", fill: "none", stroke: "var(--icon-primary-dark)", strokeLinecap: "round", strokeWidth: "2" })))))));
};
Cerrar.defaultProps = {
    className: '',
};
export default Cerrar;
